module.exports = __webpack_public_path__ + "static/media/honeycomb.cc2f8647.png";